var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, } from 'react-bootstrap';
import { cloneDeep, filter, map } from 'lodash';
import ShipmentsActionCreators from 'actions/ShipmentsActionCreators';
import ShipmentStore from 'stores/ShipmentStore';
import ProTip from '../../ui/ProTip';
import CarrierGroup from './CarrierGroup';
import { getShipmentEquipment } from '../../../helpers/shipments';
import i18next, { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
class BulkUpdateCarrierCostModal extends Component {
    constructor(props) {
        super(props);
        this.getShipmentMetadata = (shipments) => {
            const shipmentUpdates = shipments
                .reduce((current, shipment) => {
                if (shipment.order && shipment.order._id) {
                    const carrierCost = shipment.payables.find((adj) => adj.type === 'carrier_cost');
                    let equipment;
                    let reason;
                    if (carrierCost) {
                        equipment = carrierCost.equipment;
                        reason = carrierCost.reason;
                    }
                    const { _id, carrier_cost, } = shipment;
                    return Object.assign(Object.assign({}, current), { [_id]: {
                            _id,
                            carrier_cost,
                            equipment,
                            reason,
                            meta: {
                                carrier_cost,
                                equipment,
                                reason
                            },
                        } });
                }
                return current;
            }, {});
            return shipmentUpdates;
        };
        this.handleHide = () => this.props.onHide();
        this.handleShipmentsQueryUpdate = async () => {
            const selectedShipments = ShipmentStore.getShipmentsForBulkUpdate() || [];
            const shipments = selectedShipments.filter(s => s.carrier);
            const disableSaves = map(shipments, '_id') || [];
            if (shipments.length > 0) {
                const shipmentUpdates = this.getShipmentMetadata(shipments);
                const carrierGroups = groupShipmentsByCarrier(shipments);
                this.setState({ carrierGroups, disableSaves, shipmentUpdates });
            }
        };
        this.handleEquipmentChange = (shipmentId, equipment) => {
            this.setState((prevState) => {
                const { shipmentUpdates: currentShipmentUpdates, } = prevState;
                const target = cloneDeep(currentShipmentUpdates[shipmentId]);
                target.meta.equipment = equipment;
                const shipmentUpdates = Object.assign(Object.assign({}, currentShipmentUpdates), { [shipmentId]: target });
                return {
                    shipmentUpdates,
                };
            });
        };
        this.handleCarrierCostChange = (shipmentId, carrierUpdates) => {
            this.setState((prevState) => {
                var { shipmentUpdates: currentShipmentUpdates, disableSaves, } = prevState;
                const target = cloneDeep(currentShipmentUpdates[shipmentId]);
                target.meta.carrier_cost = carrierUpdates.carrierCost;
                target.meta.reason = carrierUpdates.reason;
                const shipmentUpdates = Object.assign(Object.assign({}, currentShipmentUpdates), { [shipmentId]: target });
                if (carrierUpdates && carrierUpdates.reason && carrierUpdates.reason !== null && carrierUpdates.reason.length > 0) {
                    disableSaves = filter(disableSaves, function (id) { return id !== shipmentId; });
                }
                else {
                    if (!disableSaves.includes(shipmentId)) {
                        disableSaves.push(shipmentId);
                    }
                }
                return {
                    disableSave: carrierUpdates.reason ? (carrierUpdates.reason === null || carrierUpdates.reason.length === 0) : true,
                    disableSaves: disableSaves,
                    shipmentUpdates,
                };
            });
        };
        this.handleSaveAll = () => {
            const { shipmentUpdates, } = this.state;
            const updates = Object
                .values(shipmentUpdates)
                .filter(update => (update.reason !== update.meta.reason) || (update.carrier_cost !== update.meta.carrier_cost) || (update.equipment !== update.meta.equipment))
                .map(update => ({
                _id: update._id,
                carrier_cost: update.meta.carrier_cost,
                reason: update.meta.reason,
                equipment: update.meta.equipment,
            }));
            ShipmentsActionCreators.bulkUpdateCarrierCosts({ updates });
        };
        this.handleRemoveShipment = (carrierId, shipmentId) => {
            this.setState((prevState) => {
                const { carrierGroups: currentCarrierGroups, shipmentUpdates: currentShipmentUpdates, } = prevState;
                const _a = currentShipmentUpdates, _b = shipmentId, deletedKey = _a[_b], shipmentUpdates = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
                const groupIndex = currentCarrierGroups.findIndex(g => g.id === carrierId);
                const carrierGroup = cloneDeep(currentCarrierGroups[groupIndex]);
                const shipmentIndex = carrierGroup.shipments.findIndex(s => s._id === shipmentId);
                const currentShipments = carrierGroup.shipments;
                carrierGroup.shipments = [
                    ...currentShipments.slice(0, shipmentIndex),
                    ...currentShipments.slice(shipmentIndex + 1),
                ];
                const carrierGroups = [
                    ...currentCarrierGroups.slice(0, groupIndex),
                    carrierGroup,
                    ...currentCarrierGroups.slice(groupIndex + 1),
                ];
                return {
                    carrierGroups,
                    shipmentUpdates,
                };
            });
        };
        this.handleApplyToAll = (targetShipmentId) => {
            this.setState((prevState) => {
                var { shipmentUpdates: currentShipmentUpdates, } = prevState;
                const update = currentShipmentUpdates[targetShipmentId];
                const { meta: { carrier_cost, reason, equipment, }, } = update;
                const shipmentUpdates = Object.keys(currentShipmentUpdates).reduce((updates, shipmentId) => {
                    return Object.assign(Object.assign({}, updates), { [shipmentId]: Object.assign(Object.assign({}, currentShipmentUpdates[shipmentId]), { meta: {
                                carrier_cost,
                                reason,
                                equipment,
                            } }) });
                }, {});
                return {
                    disableSaves: [],
                    disableSave: false,
                    shipmentUpdates,
                };
            });
        };
        this.handleBulkShipmentUpdateChange = () => {
            this.handleHide();
        };
        this.state = {
            proTipVisible: true,
            carrierGroups: [],
            disableSave: true,
            disableSaves: [],
            shipmentUpdates: {},
        };
    }
    componentDidMount() {
        this.initModalData(this.props);
        ShipmentStore.addChangeListener(this.handleShipmentsQueryUpdate);
        ShipmentStore.addBulkShipmentUpdateChangeListener(this.handleBulkShipmentUpdateChange);
    }
    componentWillUnmount() {
        ShipmentStore.removeChangeListener(this.handleShipmentsQueryUpdate);
        ShipmentStore.removeBulkShipmentUpdateChangeListener(this.handleBulkShipmentUpdateChange);
    }
    initModalData(props) {
        const { shipments } = props;
        ShipmentsActionCreators.getShipmentsById({ shipments });
    }
    renderProTip() {
        const { t } = this.props;
        if (!this.state.proTipVisible) {
            return null;
        }
        if (!this.state.carrierGroups.length) {
            return (React.createElement("div", { className: "mb-4" },
                React.createElement(ProTip, { message: t('ASSIGN_CARRIER_BEFORE_CARRIER_COST_UPDATE_TIP'), onClose: this.handleCloseTip })));
        }
        return (React.createElement("div", { className: "mb-4" },
            React.createElement(ProTip, { message: t('ENSURE_INFO_FILLED_BEFORE_APPLY_ALL'), onClose: this.handleCloseTip })));
    }
    render() {
        const { show, t, } = this.props;
        const { carrierGroups, shipmentUpdates, saving, } = this.state;
        const disableSaves = !!(this.state.disableSaves && this.state.disableSaves.length);
        return (React.createElement(Modal, { show: show, onHide: this.handleHide, backdrop: "static", dialogClassName: "modal-override", keyboard: false, enforceFocus: false },
            React.createElement(Modal.Header, { closeButton: true },
                React.createElement(Modal.Title, null, titleize(t('UPDATE_CARRIER_COST')))),
            React.createElement(Modal.Body, null,
                React.createElement("div", { className: "-m-4 p-4 bg-gray-100 overflow-y-auto", style: { maxHeight: '80vh' } },
                    this.renderProTip(),
                    carrierGroups.map((group) => (React.createElement(CarrierGroup, { carrierGroup: group, saving: saving, shipmentUpdates: shipmentUpdates, onCarrierCostChange: this.handleCarrierCostChange, onEquipmentChange: this.handleEquipmentChange, onApplyToAll: this.handleApplyToAll, onRemoveShipment: this.handleRemoveShipment, onSaveAll: this.handleSaveAll, disableSave: disableSaves || this.state.disableSave, disableSaves: this.state.disableSaves, key: group.id }))))),
            React.createElement(Modal.Footer, null,
                React.createElement("div", { className: "flex justify-end" },
                    React.createElement("div", { className: "md:w-1/4 mt-3" },
                        React.createElement("div", { className: "flex justify-end button-group" },
                            React.createElement("button", { className: "block button secondary-action", onClick: this.handleHide }, titleize(t('CLOSE')))))))));
    }
}
BulkUpdateCarrierCostModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    shipments: PropTypes.array,
};
function groupShipmentsByCarrier(shipments) {
    const noCarrier = {
        _id: -1,
    };
    const groupMap = shipments.reduce((group, shipment) => {
        const carrier = shipment.carrier || noCarrier;
        const { _id: carrierId, } = carrier;
        const { equipment } = shipment, currentShipment = __rest(shipment, ["equipment"]);
        currentShipment.equipments = getShipmentEquipment(shipment);
        if (group[carrierId]) {
            const carrierGroup = group[carrierId];
            carrierGroup.shipments.push(currentShipment);
            return Object.assign(Object.assign({}, group), { [carrierId]: carrierGroup });
        }
        const name = currentShipment.carrier_name || i18next.t('NO_CARRIER');
        return Object.assign(Object.assign({}, group), { [carrierId]: {
                id: carrierId,
                name,
                shipments: [currentShipment],
            } });
    }, {});
    return Object.values(groupMap);
}
export default withTranslation()(BulkUpdateCarrierCostModal);
